import { useEffect, useState } from 'react';

import { STATIC_PROGRESS_VALUE } from './constants';

/**
 * Drives a fake loading progress value from 0% up to ~90%, never completing.
 * Used by both LoadingOverlay variants to give the user a sense of motion
 * while the underlying iframe loads.
 */
export function useFakeProgress(animationDisabled: boolean): number {
	const [progress, setProgress] = useState(animationDisabled ? STATIC_PROGRESS_VALUE : 0);

	useEffect(() => {
		if (animationDisabled) {
			return;
		}

		const interval = setInterval(() => {
			setProgress((prev) => {
				if (prev < 10) {
					return prev + 10;
				}
				if (prev < 60) {
					return prev + 35;
				}
				if (prev < 90) {
					return prev + 10;
				}
				return prev;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [animationDisabled]);

	return progress;
}
